<!--
 * @Description: 
 * @Date: 2020-09-25 15:34:36
 * @LastEditors: jml
-->
<template>
  <van-form class="custom-login-form">
    <van-field
      v-model="ruleForm.localPhone"
      @input="setLocalPhone"
      type="tel"
      placeholder="请输入手机号"
      class="input"
      maxlength="13"
    ></van-field>
    <div class="flexBox">
      <van-field v-model="ruleForm.verifyCode" placeholder="获取验证码" class="input"></van-field>
      <XrkSlideVerify
        ref="verification"
        :options="verificationOptions"
        @success="checkSuccessful"
        @close="verifyClose"
      >
        <van-button
          type="info"
          class="right-content btn"
          @click="send"
          :disabled="!isPhone(ruleForm.phone) || sendLock"
        >{{ sendText }}</van-button>
      </XrkSlideVerify>
    </div>
    <van-button
      class="submit-btn"
      :disabled="!isPhone(ruleForm.phone) || !ruleForm.verifyCode"
      @click="login"
      type="info"
    >完成</van-button>
  </van-form>
</template>
<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import { customerUser, getVerification } from '@/api/ajax';
import { setStorage, getStorage } from '@/utils/storage';
import sendCodeBtn from '@/components/msgCode.vue';
export default {
  components: { sendCodeBtn },
  data() {
    return {
      ruleForm: {
        localPhone: '',
        phone: '',
        verifyCode: ''
      },
      sendMsgAjax: customerUser.sendMessageCode,
      time: new Date().getTime(),
      resendFlag: false,
      sendText: '获取验证码',
      verificationOptions: {
        // 接口请求 防抖
        remoteTimerInterval: 800,
        errorText: '请控制拼图块对齐缺口',
        successText: '验证成功',
        remoteApi: {
          initImages: getVerification,
          checkVerification: position => {
            return customerUser.sendMessageCode({
              phone: this.ruleForm.phone,
              ...position
            });
          }
        },
        errorAnimationDuration: 800
      }
    };
  },
  computed: {
    imgUrl() {
      return `${customerUser.verifyImgCode}?phone=${this.ruleForm.phone}&v=${this.time}`;
    },
    sendLock() {
      return !['重新获取', '获取验证码'].includes(this.sendText);
    }
  },
  props: {
    callback: {}
  },
  methods: {
    ...mapActions(['savePhone']),
    setLocalPhone(val) {
      this.$set(
        this.ruleForm,
        'localPhone',
        `${val}`.replace(/ /g, '').replace(/(^\d{3}\B|\d{4}\B)/g, '$1' + ' ')
      );
    },
    send() {
      if (!this.sendLock) {
        this.resendFlag = true;
        this.$refs['verification'].visible = true;
      }
    },
    checkSuccessful() {
      this.sendText = 60;
      this.countDown();
    },
    changePic() {
      this.time = new Date().getTime();
    },
    verifyClose() {
      clearInterval(this.timer);
      this.sendText = '获取验证码';
    },
    countDown() {
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.sendText !== '重新获取' && this.sendText > 0) {
          this.sendText--;
        } else {
          this.sendText = '重新获取';
          clearInterval(this.timer);
        }
      }, 1000);
    },
    isPhone(item) {
      return /^1[0-9]{10}$/.test(`${item}`);
    },
    async login() {
      if (!this.isPhone(this.ruleForm.phone)) {
        this.$toast('请输入正确的手机号');
      } else if (!this.ruleForm.verifyCode) {
        this.$toast('请输入短信验证码');
      } else {
        const {
          data: { data }
        } = await customerUser.verifyLogin({
          phone: this.ruleForm.phone,
          verifyCode: this.ruleForm.verifyCode,
          activityReferralCode: this.$route.query.activityReferralCode
        });
        let { token, user, channel, tJhEnterpriseChannelWhiteList } = data;
        user.token = token;
        let storageName = 'channel' + this.$route.params.channelNo;
        setStorage(storageName, user);
        this.$sa.login(user.id);
        this.callback && this.callback(user);
        try {
          this.$parent.$parent.show = false;
        } catch (error) {
          console.warn(error);
        }
      }
    }
  },
  watch: {
    'ruleForm.localPhone': {
      handler(newV) {
        this.$set(this.ruleForm, 'phone', newV.replace(/ /g, ''));
      },
      deep: true
    }
  },
  async created() {}
};
</script>
<style lang='less'>
.custom-login-form {
  .van-cell {
    font-size: 0.43rem;
    padding: 0.43rem 0;
    border-bottom: 1px solid #e8e9ec;
    margin-bottom: 0.65rem;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .flexBox {
    position: relative;
    margin-bottom: 0.65rem;
    &:last-of-type {
      margin-bottom: 0;
    }
    .van-field__value {
      padding-right: 2.98rem;
    }
    .right-content {
      position: absolute;
      width: 2.4rem;
      height: 1.01rem;
      right: 0;
      top: 0.2rem;
      &.btn {
        padding: 0;
      }
    }
  }
  .submit-btn {
    margin-top: 1rem;
    width: 100%;
    height: 1.28rem;
    border-radius: 0.11rem;
    font-size: 0.48rem;
    font-weight: 500;
    color: #fff;
  }
}
</style>